import React, { useState, useEffect, useCallback } from 'react';
import Login from './Login';
import Register from './Register';
import Layout from './Layout';
import Dashboard from './Dashboard';
import Conversations from './Conversations';
import Orders from './Orders';
import Contacts from './Contacts';
import Flows from './Flows';
import Marketing from './Marketing';
import Campaigns from './Campaigns';
import Settings from './Settings';
import Admin from './Admin';
// ContingencyOrders.js se conserva como respaldo pero ya no se expone como UI (Fase 3).
import VideoAI from './VideoAI';

const PATH_TO_SCREEN = {
  '/': 'Dashboard',
  '/conversaciones': 'Conversaciones',
  '/pedidos': 'Pedidos',
  '/contactos': 'Contactos',
  '/flujos': 'Flujos',
  '/marketing': 'Marketing',
  '/campanas': 'Campañas',
  '/configuracion': 'Configuraciones',
  '/video-ia': 'Video IA',
};
const SCREEN_TO_PATH = {};
Object.keys(PATH_TO_SCREEN).forEach(k => { SCREEN_TO_PATH[PATH_TO_SCREEN[k]] = k; });

function readURL() {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const screen = PATH_TO_SCREEN[path] || 'Dashboard';
  const phone = params.get('phone') || null;
  return { screen, phone };
}

function MainApp() {
  const [user, setUser] = useState(() => {
    try {
      const saved = localStorage.getItem('talku_user');
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  const [screen, setScreen] = useState(() => readURL().screen);
  const [convPhone, setConvPhone] = useState(() => readURL().phone);
  const [authView,  setAuthView]  = useState('login');

  const pushURL = useCallback((s, phone) => {
    const base = SCREEN_TO_PATH[s] || '/';
    const qs = (s === 'Conversaciones' && phone) ? `?phone=${encodeURIComponent(phone)}` : '';
    const target = base + qs;
    if (window.location.pathname + window.location.search !== target) {
      window.history.pushState({ screen: s, phone }, '', target);
    }
  }, []);

  useEffect(() => {
    const onPop = () => {
      const { screen: s, phone } = readURL();
      setScreen(s);
      if (s === 'Conversaciones' && phone) setConvPhone(phone);
    };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const handleLogin = (userData) => {
    localStorage.setItem('talku_user', JSON.stringify(userData));
    setUser(userData);
    setAuthView('login');
  };

  const handleLogout = () => {
    localStorage.removeItem('talku_user');
    localStorage.removeItem('talku_token');
    setUser(null);
    setScreen('Dashboard');
    pushURL('Dashboard');
  };

  const handleNav = (s, phone) => {
    if (s === 'Conversaciones' && phone) setConvPhone(phone);
    else if (s !== 'Conversaciones') setConvPhone(null);
    setScreen(s);
    pushURL(s, phone);
  };

  if (!user) {
    if (authView === 'register') return <Register onLogin={handleLogin} onShowLogin={() => setAuthView('login')} />;
    return <Login onLogin={handleLogin} onShowRegister={() => setAuthView('register')} />;
  }

  return (
    <Layout
      user={user}
      activeNav={screen}
      onNav={handleNav}
      onLogout={handleLogout}
    >
      {screen === 'Dashboard'       && <Dashboard          user={user} onNav={handleNav} onLogout={handleLogout} />}
      {screen === 'Conversaciones'  && <Conversations      user={user} onNav={handleNav} onLogout={handleLogout} initialPhone={convPhone} noShell />}
      {screen === 'Pedidos'         && <Orders             user={user} onNav={handleNav} onLogout={handleLogout} noShell />}
      {screen === 'Contactos'       && <Contacts           user={user} onNav={setScreen} onLogout={handleLogout} noShell />}
      {screen === 'Flujos'          && <Flows              user={user} onNav={setScreen} onLogout={handleLogout} noShell />}
      {screen === 'Marketing'       && <Marketing          user={user} onNav={setScreen} onLogout={handleLogout} noShell />}
      {screen === 'Campañas'        && <Campaigns          user={user} onNav={setScreen} onLogout={handleLogout} noShell />}
      {screen === 'Configuraciones' && <Settings           user={user} onNav={setScreen} onLogout={handleLogout} noShell />}
      {screen === 'Video IA'        && <VideoAI            user={user} onNav={handleNav} onLogout={handleLogout} />}
    </Layout>
  );
}

function App() {
  if (window.location.pathname === '/admin') return <Admin />;
  return <MainApp />;
}

export default App;
